export const COMPONENT_NAME = 'FaqAccordion';
